"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const radio_input_style_1 = require("../../components/input/radio.input.style");
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-DepartmentSelector',
    btn: 'c-DepartmentSelector__Btn',
    icon: 'c-DepartmentSelector__Icon',
    department: 'c-DepartmentSelector__Department',
    departmentOptions: 'c-DepartmentSelector__Options',
    departmentOption: 'c-DepartmentSelector__Option',
    departmentDisabled: 'c-DepartmentSelector__Department__Disabled',
};
exports.Style = {
    [exports.CSS.container]: {
        position: 'relative',
    },
    [exports.CSS.btn]: {
        display: 'flex',
        'align-items': 'center',
        'max-width': '300px',
        'text-transform': 'none',
    },
    [exports.CSS.department]: {
        margin: `0 ${theme_1.DefaultTheme.space(2)}`,
        color: theme_1.DefaultTheme.font.color.white,
        'font-weight': theme_1.DefaultTheme.font.weight.normal,
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
    },
    [exports.CSS.departmentOptions]: {
        width: '600px',
        display: 'flex',
        'flex-direction': 'column',
        [`& .${radio_input_style_1.CSS.container}`]: {
            cursor: 'pointer',
            'border-bottom': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
            color: theme_1.DefaultTheme.font.color.primary,
        },
        [`& .${radio_input_style_1.CSS.container}:hover`]: {
            'background-color': theme_1.DefaultTheme.background.lightGrey,
        },
    },
    [exports.CSS.departmentDisabled]: {
        color: theme_1.DefaultTheme.font.color.error,
    },
};
//# sourceMappingURL=department.selector.style.js.map